module.exports = __webpack_public_path__ + "img/ok.1444ab15.png";